import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { confirmPasswordReset } from "../../lib/api";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const [uid, setUid] = useState("");
  const [token, setToken] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    setUid(qs.get("uid") || "");
    setToken(qs.get("token") || "");
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (!uid || !token) {
      setErr(t("resetPassword.invalidLink"));
      return;
    }
    if (p1 !== p2) {
      setErr(t("resetPassword.noMatch"));
      return;
    }
    if ((p1 || "").length < 8) {
      setErr(t("resetPassword.tooShort"));
      return;
    }

    try {
      setLoading(true);
      await confirmPasswordReset({ uid, token, new_password: p1 });

      sessionStorage.setItem("flash_msg", t("resetPassword.flashSuccess"));
      window.location.href = "/app/login";
    } catch (e) {
      const d = e?.response?.data;
      setErr(
        (d && (d.token || d.uid || d.new_password)?.toString()) ||
          t("resetPassword.invalidToken")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <form
        onSubmit={onSubmit}
        className="w-[420px] p-6 rounded-2xl shadow border space-y-4"
      >
        <h1 className="text-2xl font-semibold">{t("resetPassword.setNew")}</h1>
        {msg && <p className="text-green-600 text-sm">{msg}</p>}
        {err && <p className="text-red-600 text-sm">{err}</p>}

        <label className="block">
          <span className="text-sm">{t("resetPassword.password")}</span>
          <input
            type="password"
            className="mt-1 w-full border rounded px-3 py-2"
            value={p1}
            onChange={(e) => setP1(e.target.value)}
          />
        </label>

        <label className="block">
          <span className="text-sm">{t("resetPassword.passwordConfirm")}</span>
          <input
            type="password"
            className="mt-1 w-full border rounded px-3 py-2"
            value={p2}
            onChange={(e) => setP2(e.target.value)}
          />
        </label>

        <button
          className="w-full bg-black text-white rounded py-2 disabled:opacity-60"
          disabled={loading}
        >
          {loading ? t("resetPassword.processing") : t("resetPassword.resetBtn")}
        </button>
      </form>
    </div>
  );
}
